import { playgroundEnabled } from '@mfox/shared/lib/demoMode'
import type { User } from '@mfox/shared/contexts/UserContext'
import type { AppFrameBarTab, AppFrameTab } from './AppFrame'

/**
 * The student area's tabs, as the laptop sidebar lists them. The app shell and the course pages (which sit outside
 * it, so the player can own the whole screen) both show them. Playground follows the same condition as its routes
 * in routes.tsx: a tab to a route that doesn't exist would be a 404. Profile lives in the account menu, not here.
 */
export const STUDENT_TABS: AppFrameTab[] = [
  { to: '/home', label: 'Home', also: ['/leaderboard'] },
  { to: '/roadmap', label: 'Roadmap' },
  { to: '/course', label: 'Course', also: ['/mentor-assessment'] },
  { to: '/tests', label: 'Practice tests' },
  ...(playgroundEnabled ? [{ to: '/playground', label: 'Playground' }] : []),
  { to: '/opportunities', label: 'Career opportunities', feature: 'opportunities' },
]

/** The phone's bottom tab bar: the four places a student spends their time. Every other tab is under More. */
export const STUDENT_BAR: AppFrameBarTab[] = [
  { to: '/home', label: 'Home', icon: 'home', also: ['/leaderboard'] },
  { to: '/course', label: 'Course', icon: 'course', also: ['/mentor-assessment'] },
  { to: '/tests', label: 'Tests', icon: 'tests' },
  { to: '/roadmap', label: 'Roadmap', icon: 'roadmap' },
]

/** MentorFox admins can open the student area to check it; the first tab takes them back to their own. */
export function studentTabsFor(role: User['role'] | undefined): AppFrameTab[] {
  return role === 'mfox' ? [{ to: '/admin', label: '← Admin' }, ...STUDENT_TABS] : STUDENT_TABS
}

/** Only students have a profile page; an admin looking around the student area has none. */
export function studentProfileFor(role: User['role'] | undefined): string | undefined {
  return role === 'student' ? '/profile' : undefined
}
